import moment from "moment";

const allAvailableWeekDays = [
  { name: "lunes", creation_week_day: 1 },
  { name: "martes", creation_week_day: 2 },
  { name: "miércoles", creation_week_day: 3 },
  { name: "jueves", creation_week_day: 4 },
  { name: "viernes", creation_week_day: 5 },
];

export const getMomentDateByDayNumber = (dayNumber) => {
  const initialDate = moment();
  let found = false;
  while (!found) {
    if (initialDate.day() == dayNumber) found = true;
    else initialDate.add(1, "day");
  }
  return initialDate;
};

export const getAllAvailableWeekDays = () => {
  return allAvailableWeekDays;
};

export const getWeekDayByCreationWeekDayNumber = (creationWeekDayNumber) => {
  return allAvailableWeekDays.find((day) => day.creation_week_day === creationWeekDayNumber);
};

export const getNextDeliveryDateByCreationWeekDay = (creationWeekDay) => {
  const now = moment();
  const nextDeliveryDate = moment().add(2, "day");
  if (now.hour() > 20) nextDeliveryDate.add(1, "day");
  let found = false;
  let countDays = 0;
  while (!found && countDays < 30) {
    if (nextDeliveryDate.day() === creationWeekDay) {
      return nextDeliveryDate;
    } else {
      nextDeliveryDate.add(1, "day");
      countDays++;
    }
  }
  return null;
};

export const getAvailableSchedulesByCityZone = (
  cityZone,
  creationWeekDay,
  extendedProgramSchedule
) => {
  if (cityZone && cityZone.delivery_schedule) {
    const { hour_range } = cityZone.delivery_schedule;
    const formattedHourRanges = hour_range.map((hourRange) => {
      const splittedHourRange = hourRange.replace(/ /g, "").split(",");
      const hour1 = moment(splittedHourRange[0], "HH:mm");
      const hour2 = moment(splittedHourRange[1], "HH:mm");
      return `${hour1.format("hh:mm A")} - ${hour2.format("hh:mm A")}`;
    });
    if (creationWeekDay.creation_week_day !== 1) {
      const findIndex = formattedHourRanges.findIndex(
        (hourRange) => hourRange === extendedProgramSchedule
      );
      if (findIndex !== -1) formattedHourRanges.splice(findIndex, 1);
    }
    return formattedHourRanges;
  }
  return [];
};
